

// 二维数组转一维数组
export const flatten = (arr) => {
    return [].concat( ...arr.map(x => Array.isArray(x) ? flatten(x) : x) )
}

// 异步加载图片
export const loadImageAsync = (url) => {
    return new Promise((resolve, reject) => {
        const image = new Image()
        image.onload = () => {
            resolve(image)
        }
        image.onerror = () => {
            reject(new Error('Could not load image at' + url))
        }
        image.src = url
    })
}